export function extractFilterResourceTypes(queryString: string): string[] {
  const searchParams = new URLSearchParams(queryString);
  const filterResourceTypes = searchParams.get("filter_resource_types");

  if (filterResourceTypes) {
    return filterResourceTypes.split(",");
  }

  return [];
}

export const onSpaceHandler = (link: string) => {
  window.open(link, '_blank');
};

export const defaultPopupDetails = {
  link: '',
  image: '',
  title: '',
  rating: {
    revs: 0,
    star_rating: 0,
  },
  address: '',
  price: 0,
  currency: '',
  reviews: 0,
};

export const isProduction = window.location.hostname === 'www.coworker.com' || window.location.hostname === 'www.staging.coworker.com';

const hostname = window.location.hostname;
const isValid = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(hostname);
export const baseURL = `https://${isValid ? hostname : 'www.coworker.com'}/`;